import { render, staticRenderFns } from "./addBuyerDialog.vue?vue&type=template&id=15d04e90&"
import script from "./addBuyerDialog.vue?vue&type=script&lang=js&"
export * from "./addBuyerDialog.vue?vue&type=script&lang=js&"
import style0 from "./addBuyerDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d04e90')) {
      api.createRecord('15d04e90', component.options)
    } else {
      api.reload('15d04e90', component.options)
    }
    module.hot.accept("./addBuyerDialog.vue?vue&type=template&id=15d04e90&", function () {
      api.rerender('15d04e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Role/components/addBuyerDialog.vue"
export default component.exports